const initSendEventToGTM =
	({ window }) =>
	(dataLayerParams) => {
		const loadEventFired = window.document.readyState === "complete";
		if (loadEventFired) {
			if (window.dataLayer) {
				window.dataLayer.push(dataLayerParams);
			} else {
				console.error(
					`ERROR: GTM DATALAYER NOT AVAILABLE FOR EVENT ${dataLayerParams.event}`,
				);
			}
		} else {
			// This is so that we only push the event after GTM is intialized
			window.addEventListener("load", () => {
				window.dataLayer.push(dataLayerParams);
			});
		}
	};
const sendEventToGTM = initSendEventToGTM({ window });

export { initSendEventToGTM, sendEventToGTM };
